/* KPaul Supply — header + home interactions (desktop).
   1) open the top category dropdowns on hover
   2) duplicate the brand logos for a seamless running loop
   3) drag/swipe the Featured Products row
   (The announcement marquee and the sub-category flyout are now
    handled by the section markup + CSS — no JS needed.)         */
(function () {

  function openOnHover() {
    document.querySelectorAll('.header__inline-menu header-menu').forEach(function (menu) {
      var details = menu.querySelector('details.mega-menu');
      if (!details || menu.dataset.kpHover) return;
      menu.dataset.kpHover = '1';
      var t;
      menu.addEventListener('mouseenter', function () {
        clearTimeout(t);
        document.querySelectorAll('.header__inline-menu details.mega-menu[open]')
          .forEach(function (d) { if (d !== details) d.removeAttribute('open'); });
        details.setAttribute('open', '');
      });
      menu.addEventListener('mouseleave', function () {
        t = setTimeout(function () { details.removeAttribute('open'); }, 120);
      });
    });

    document.addEventListener('click', function (e) {
      if (e.target.closest('.header__inline-menu')) return;
      document.querySelectorAll('.header__inline-menu details.mega-menu[open]')
        .forEach(function (d) { d.removeAttribute('open'); });
    });
  }

  function brandMarquee() {
    document.querySelectorAll('[id$="__multicolumn_daXbDz"] .multicolumn-list').forEach(function (list) {
      if (list.dataset.kpMarquee) return;
      list.dataset.kpMarquee = '1';
      Array.prototype.slice.call(list.children).forEach(function (li) {
        var clone = li.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        list.appendChild(clone);
      });
    });
  }

  function dragScroll(el) {
    var down = false, sx = 0, sl = 0, moved = false;
    el.addEventListener('pointerdown', function (e) {
      if (e.button !== 0) return;
      down = true; moved = false; sx = e.clientX; sl = el.scrollLeft;
      el.classList.add('kp-grabbing');
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - sx;
      if (Math.abs(dx) > 4) moved = true;
      el.scrollLeft = sl - dx;
    });
    window.addEventListener('pointerup', function () {
      if (!down) return;
      down = false; el.classList.remove('kp-grabbing');
    });
    el.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); }
    }, true);
  }

  function featuredSlider() {
    document.querySelectorAll('[id$="__featured_collection"] .product-grid').forEach(function (g) {
      if (g.dataset.kpDrag) return;
      g.dataset.kpDrag = '1';
      dragScroll(g);
    });
  }

  function collectionFilters() {
    var wrap = document.querySelector('.facets-vertical');
    var sidebar = document.querySelector('.facets-vertical .facets-wrapper')
               || document.querySelector('.facets-wrapper');
    if (!wrap || !sidebar || wrap.dataset.kpFilters) return;
    wrap.dataset.kpFilters = '1';
    document.body.classList.add('kp-has-filter-drawer');

    // Filter button (placed above the results area)
    var bar = document.createElement('div');
    bar.className = 'kp-filterbar';
    bar.innerHTML =
      '<button type="button" class="kp-filter-btn">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 5h16M7 12h10M10 19h4"/></svg>' +
      'Filter</button>';
    wrap.parentNode.insertBefore(bar, wrap);
    var btn = bar.querySelector('.kp-filter-btn');

    // overlay
    var ov = document.createElement('div');
    ov.className = 'kp-filter-overlay';
    document.body.appendChild(ov);

    // drawer header with close
    var head = document.createElement('div');
    head.className = 'kp-filter-head';
    head.innerHTML = '<span>Filters</span>' +
      '<button type="button" class="kp-filter-close" aria-label="Close filters">&times;</button>';
    sidebar.insertBefore(head, sidebar.firstChild);

    function open() { document.body.classList.add('kp-filter-open'); }
    function shut() { document.body.classList.remove('kp-filter-open'); }
    btn.addEventListener('click', open);
    head.querySelector('.kp-filter-close').addEventListener('click', shut);
    ov.addEventListener('click', shut);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') shut(); });
  }

  function stickyAtc() {
    var section = document.querySelector('.product');
    if (!section || document.querySelector('.kp-atc-bar')) return;
    var titleEl = section.querySelector('.product__title');
    var realBtn = section.querySelector('.product-form__submit');
    var priceEl = section.querySelector('.price .price-item--regular, .price .price-item');
    if (!titleEl || !realBtn) return;

    var titleText = (titleEl.querySelector('h1') || titleEl).textContent.trim();
    var imgEl = section.querySelector('.product__media img, .product__media-item img, .product__media-wrapper img');
    var imgSrc = imgEl ? (imgEl.currentSrc || imgEl.src) : '';

    var bar = document.createElement('div');
    bar.className = 'kp-atc-bar';
    bar.innerHTML =
      '<div class="kp-atc-bar__inner page-width">' +
        (imgSrc ? '<img class="kp-atc-bar__img" src="' + imgSrc + '" alt="">' : '') +
        '<div class="kp-atc-bar__info">' +
          '<span class="kp-atc-bar__title">' + titleText + '</span>' +
          (priceEl ? '<span class="kp-atc-bar__price">' + priceEl.textContent.trim() + '</span>' : '') +
        '</div>' +
        '<button type="button" class="kp-atc-bar__btn">Add to cart</button>' +
      '</div>';
    document.body.appendChild(bar);
    bar.querySelector('.kp-atc-bar__btn').addEventListener('click', function () { realBtn.click(); });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          // show the bar once the real button has scrolled above the viewport
          var above = e.boundingClientRect.top < 0;
          document.body.classList.toggle('kp-atc-visible', !e.isIntersecting && above);
        });
      }, { threshold: 0 });
      io.observe(realBtn);
    }
  }

  function relatedDrag() {
    document.querySelectorAll('.related-products .product-grid').forEach(function (g) {
      if (g.dataset.kpDrag) return;
      g.dataset.kpDrag = '1';
      dragScroll(g);
    });
  }

  function collectionBadges() {
    if (!document.querySelector('.facets-vertical')) return;
    var badges = document.querySelector('.facets-vertical .productIcons, .productIcons');
    var grid = document.querySelector('.product-grid-container');
    if (!badges || !grid || badges.dataset.kpMoved) return;
    badges.dataset.kpMoved = '1';
    badges.classList.add('kp-badgestrip');
    grid.parentNode.insertBefore(badges, grid.nextSibling);
  }

  function pdpBadges() {
    var media = document.querySelector('.product__media-wrapper');
    var badges = document.querySelector('.productIcons');
    if (!media || !badges || badges.dataset.kpPdp) return;
    badges.dataset.kpPdp = '1';
    badges.classList.add('kp-pdp-badges');
    media.appendChild(badges);           /* under the product image, left column */
    // shorten the long label so all 4 fit on one line
    badges.querySelectorAll('li').forEach(function (li) {
      if (/300,?000/.test(li.textContent)) li.textContent = '300K+ products';
    });
  }

  function productTabsDefault() {
    var root = document.querySelector('.kp-tabs');
    if (!root) return;
    var specsBtn = root.querySelector('.kp-tab[data-kptab="specs"]');
    var specsPane = root.querySelector('#kp-pane-specs');
    if (!specsBtn || !specsPane) return;
    root.querySelectorAll('.kp-tab').forEach(function (b) { b.classList.remove('is-active'); });
    root.querySelectorAll('.kp-pane').forEach(function (p) { p.classList.remove('is-active'); });
    specsBtn.classList.add('is-active');
    specsPane.classList.add('is-active');
  }

  function init() { brandMarquee(); featuredSlider(); stickyAtc(); relatedDrag(); pdpBadges(); productTabsDefault(); }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  document.addEventListener('shopify:section:load', function () {
    brandMarquee(); featuredSlider(); stickyAtc(); relatedDrag(); pdpBadges(); productTabsDefault();
  });
})();